export default __webpack_public_path__ + "static/media/p1.0b7b177a.jpg";